import {useContext, useEffect, useState} from "react";
import {RuoliContext} from "../../../context/RuoliContext";
import ContenutoTitoloArchivioView from "./ContenutoTitoloArchivioView";

export default function ContenutoTitoliArchivioController({
                                                              idMarca,
                                                              titoli,
                                                              handlerRefreshTitoli,
                                                              selectTitolo,
                                                          }) {

    const [showModalAddTitolo, setShowModalAddTitolo] = useState(false);

    const {
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia,
    } = useContext(RuoliContext);

    return (
        <ContenutoTitoloArchivioView
            titoli={titoli}
            idMarca={idMarca}
            isRuoloAd={!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia()}
            openModalAddTitolo={() => {
                setShowModalAddTitolo(true);
            }}
            closeModalAddTitolo={() => {
                setShowModalAddTitolo(false);
            }}
            addTitoloOk={(titolo) => {
                setShowModalAddTitolo(false);
                handlerRefreshTitoli();
            }}
            showModalAddDoc={showModalAddTitolo}
            selectTitolo={selectTitolo}
        />
    );
}